import React from 'react';
import Icon from '../muiComponents/Icon';

interface IStatusCellProps {
    text: string;
    color?: string;
}

const StatusCell = ({ text, color }: IStatusCellProps) => {
    return (
        <span className='flex flex-align-center gap-5'>
            <Icon
                iconName='FiberManualRecord'
                style={{
                    color,
                    fontSize: '14px',
                }}
            />
            {text}
        </span>
    );
};

export default StatusCell;
